import { CdkDragDrop, transferArrayItem } from '@angular/cdk/drag-drop';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { debounceTime, distinctUntilChanged, startWith } from 'rxjs/operators';
import { LmoFracMineService } from '~lmo/services/lmo-frac-mine.service';
import { Mine } from '~v2Models/mine.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'sa-lmo-frac-fcpo-manage-loaders',
  styleUrls: ['./lmo-frac-fcpo-manage-loaders.component.scss'],
  templateUrl: './lmo-frac-fcpo-manage-loaders.component.html',
})
export class LmoFracFcpoManageLoadersComponent implements OnInit {
  public loading$$ = new BehaviorSubject(true);
  public outOfNetworkLoaders: Mine[] = [];
  public inNetworkLoaders: Mine[] = [];
  public inNetworkSearch = new FormControl();
  public outOfNetworkSearch = new FormControl();

  constructor(private cd: ChangeDetectorRef, private fracMineService: LmoFracMineService) {}

  public ngOnInit() {
    this.loadData();
  }

  public drop(event: CdkDragDrop<Mine[]>) {
    if (event.previousContainer !== event.container) {
      this.loading$$.next(true);
      const mine: Mine = event.previousContainer.data[event.previousIndex];
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
      if (event.container.id === 'inNetwork') {
        this.fracMineService.addContractMine$(mine.id).subscribe(() => {
          this.loadData();
        });
      } else if (event.container.id === 'outOfNetwork') {
        this.fracMineService.removeInNetworkLoader$(mine.id).subscribe(() => {
          this.loadData();
        });
      }
    }
  }

  private loadData() {
    this.loading$$.next(true);
    combineLatest(
      this.fracMineService.getOutOfNetworkLoaders$(),
      this.outOfNetworkSearch.valueChanges.pipe(
        debounceTime(500),
        distinctUntilChanged(),
        startWith(''),
      ),
    ).subscribe(([loaders, value]) => {
      value = (value && value.toLowerCase()) || '';
      this.outOfNetworkLoaders = [
        ...loaders.filter((loader) => loader.site.name.toLowerCase().indexOf(value) > -1).sort(this.sortLoaders),
      ];
      this.cd.detectChanges();
    });
    combineLatest(
      this.fracMineService.getFracMines$(),
      this.inNetworkSearch.valueChanges.pipe(
        debounceTime(500),
        distinctUntilChanged(),
        startWith(''),
      ),
    ).subscribe(([loaders, value]) => {
      value = (value && value.toLowerCase()) || '';
      this.inNetworkLoaders = [
        ...loaders.filter((loader) => loader.site.name.toLowerCase().indexOf(value) > -1).sort(this.sortLoaders),
      ];
      this.cd.detectChanges();
    });
  }

  private sortLoaders(a, b) {
    a = a.site.name.toLowerCase();
    b = b.site.name.toLowerCase();
    return a < b ? -1 : a > b ? 1 : 0;
  }
}
